var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRapidoReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(1373 -1301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-report-3888508",
    transform: "translate(-1373 1301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(20.001 52.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M188.334,141.167a4,4,0,0,1,0,5.657l-15,15a4,4,0,0,1-5.657,0l-9-9a4,4,0,0,1,5.657-5.657l6.171,6.171,12.171-12.171A4,4,0,0,1,188.334,141.167Z",
    transform: "translate(-157.506 -139.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M336.5,175a4,4,0,1,0,0,8h40a4,4,0,1,0,0-8Z",
    transform: "translate(-292.501 -166.999)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(20.001 22.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M332.5,354a4,4,0,0,1,4-4h40a4,4,0,0,1,0,8h-40A4,4,0,0,1,332.5,354Z",
    transform: "translate(-292.501 -342.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M188.334,321.834a4,4,0,1,0-5.657-5.657l-12.171,12.171-6.171-6.171a4,4,0,0,0-5.657,5.657l9,9a4,4,0,0,0,5.657,0Z",
    transform: "translate(-157.506 -315.006)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(20.001 82.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M332.5,354a4,4,0,0,1,4-4h40a4,4,0,0,1,0,8h-40A4,4,0,0,1,332.5,354Z",
    transform: "translate(-292.501 -342.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M188.334,321.834a4,4,0,1,0-5.657-5.657l-12.171,12.171-6.171-6.171a4,4,0,0,0-5.657,5.657l9,9a4,4,0,0,0,5.657,0Z",
    transform: "translate(-157.506 -315.006)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M70,116a12,12,0,0,0,12,12H186a12,12,0,0,0,12-12V12A12,12,0,0,0,186,0H82A12,12,0,0,0,70,12Zm12,4a4,4,0,0,1-4-4V12a4,4,0,0,1,4-4H186a4,4,0,0,1,4,4V116a4,4,0,0,1-4,4Z",
    transform: "translate(-70)",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapidoReport);
export default __webpack_public_path__ + "static/media/rapidoReport.75a5250c2ec5c8ecc976c23a5a545623.svg";
export { ForwardRef as ReactComponent };